import { FormSection, SectionNotice } from '../editorParts';

/**
 * Só com formato KIT (os 28 que vieram do Bling). Nada editável: composição,
 * tipo de estoque e baixa continuam no Bling; aqui se edita o cadastro do kit.
 */
const KitNoticeSection = () => (
    <FormSection
        id="composicao"
        title="Composição"
        notice={
            <SectionNotice tone="info">
                A composição deste kit (componentes, tipo de estoque e baixa) é mantida no Bling. Aqui você edita só o
                cadastro do kit. Kit novo: cadastre no Bling.
            </SectionNotice>
        }
    />
);

export default KitNoticeSection;
